import React, { useEffect, useState } from 'react';
import { MapPin, CheckCircle2 } from 'lucide-react';
const NAMES = ['Marcelo', 'Carlos', 'Fabián', 'Santiago', 'Diego', 'Cecilia', 'Juan', 'Martín', 'Lucas', 'Pablo', 'Alejandro', 'Nicolás'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Santa Fe', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const showPopup = () => {
      setBuyer({
        name: NAMES[Math.floor(Math.random() * NAMES.length)],
        city: CITIES[Math.floor(Math.random() * CITIES.length)]
      });
      setIsVisible(true);
      hideTimer = setTimeout(() => setIsVisible(false), 5000);
    };
    // Fire every 30 seconds, with a short initial delay.
    const initialTimer = setTimeout(showPopup, 8000);
    const recurringTimer = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(hideTimer);
      clearInterval(recurringTimer);
    };
  }, []);
  return <div aria-live="polite" className={`fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-2xl border border-gray-100 p-4 flex items-start gap-4 transition-all duration-300 ease-out ${isVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'}`} data-id="element-31">
      <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-32">
        <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-33" />
      </div>
      <div data-id="element-34">
        <p className="text-sm text-gray-500 font-medium mb-1" data-id="element-35">
          Alguien acaba de comprar
        </p>
        <p className="text-base font-bold text-gray-900 leading-tight" data-id="element-36">
          Megapack FUTSAL 360
        </p>
        <div className="flex items-center gap-1 mt-2 text-xs text-gray-500" data-id="element-37">
          <MapPin className="w-3 h-3" data-id="element-38" />
          <span data-id="element-39">
            {buyer.name} de {buyer.city}, 🇦🇷
          </span>
        </div>
        <p className="text-xs text-gray-400 mt-1" data-id="element-40">Hace unos minutos</p>
      </div>
    </div>;
}